import { StepperLinesProps } from './StepperLines.types';

export const getStepperLinesColor = (
    num: number,
    currentStep: number,
    color: NonNullable<StepperLinesProps['color']>
) => {
    if (currentStep === num) return 'midnight100';
    if (num < currentStep) return color;

    return 'midnight40';
};
